import restaurants from "@/content/restaurants.json";
import Reveal from "@/components/home/Reveal";
import { MapPin, Globe2, ExternalLink, ShieldCheck } from "lucide-react";

const LogoChip = ({ name, logo }) => (
  <span className="inline-flex items-center gap-3 rounded-full bg-white border border-orange-100 pl-1.5 pr-5 py-1.5 shadow-sm whitespace-nowrap select-none">
    <img src={logo} alt={name} loading="lazy" className="w-9 h-9 rounded-full object-cover bg-gray-100" />
    <span className="font-heading font-semibold text-sm text-gray-700">{name}</span>
  </span>
);

export const SocialProof = () => {
  const marquee = [...restaurants.global, ...restaurants.global];
  return (
    <section className="bg-white border-y border-orange-100" data-testid="social-proof-section">
      <div className="mt-container py-12 lg:py-16">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-wider">Recién llegados a México</p>
            <h2 className="mt-2 font-heading font-bold text-2xl sm:text-3xl leading-tight text-brand-carbon" data-testid="social-proof-headline">Restaurantes que ya venden con MenuThere en México</h2>
          </div>
          <p className="text-sm text-gray-500 flex items-center gap-1.5"><MapPin className="w-4 h-4 text-brand-orange" /> Los primeros de muchos. ¿El siguiente es el tuyo?</p>
        </Reveal>

        <div className="mt-8 grid sm:grid-cols-3 gap-4" data-testid="mx-restaurants">
          {restaurants.mexico.map(({ slug, name, logo, url }, i) => (
            <Reveal key={slug} delay={i * 90}>
              <a href={url} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 rounded-2xl border border-orange-100 bg-brand-cream/60 p-4 hover:bg-white hover:shadow-[0_14px_40px_rgba(255,102,18,0.14)] hover:-translate-y-0.5 transition-all" data-testid={`mx-restaurant-${slug}`}>
                <img src={logo} alt={name} className="w-16 h-16 rounded-2xl object-cover bg-white shadow-sm shrink-0" />
                <div className="min-w-0">
                  <p className="font-heading font-bold text-brand-carbon leading-snug">{name}</p>
                  <p className="mt-1 text-xs text-brand-green font-semibold inline-flex items-center gap-1">Menú en línea activo <ExternalLink className="w-3 h-3 opacity-60 group-hover:opacity-100" /></p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-12">
          <p className="text-sm text-gray-500 flex items-center gap-2 mb-4"><Globe2 className="w-4 h-4 text-brand-orange" /> Y más de 600 restaurantes ya venden con MenuThere en el mundo, con su propia app:</p>
          <div className="overflow-hidden relative [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]" data-testid="global-marquee">
            <div className="marquee !gap-4">
              {marquee.map((r, i) => <LogoChip key={`${r.slug}-${i}`} {...r} />)}
            </div>
          </div>
        </Reveal>

        <Reveal delay={160} className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-gray-600">
          <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-brand-green" /> Proveedor tecnológico oficial de Meta (WhatsApp Business Platform)</span>
          <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-brand-green" /> Apps publicadas en Google Play y App Store</span>
        </Reveal>
      </div>
    </section>
  );
};

export default SocialProof;
